module.exports = __webpack_public_path__ + "static/media/calendar-times.f31136a0.svg";